(function ($) {
  Drupal.behaviors.headerNavFormatterV1 = {
    attach: function (context, settings) {
      $('.header-nav-formatter-v1').each(function () {
        var thisFormatter = $(this);
        // Get URL path
        var wl = window.location;
        var domain = wl.host;
        var pathname = wl.pathname;
        var pathArray = wl.pathname.split('/');
        var pathFirst = pathArray[1].replace(',', '');
        var pathLast = typeof pathArray[2] != 'undefined' ? pathArray[2].replace(',', '-') : '';
        // Not sure if a body class is needed, but just in case. It can become handy later...
        var bodyClass = pathFirst + '-' + pathLast;

        $('body').addClass(bodyClass);

        // Find links href attr match with URL path and add active CSS class
        var aHref,
          aHrefHash,
          urlHash;

        thisFormatter.find('.shortcuts').find('li').each(function (i) {
          var item = $(this);

          aHref = item.find('a').attr('href').split('#')[0];
          aHrefHash = item.find('a').attr('href').split('#')[1];
          urlHash = wl.href.split('#')[1];

          item.find('a').on('click', function() {
            var thisItem = $(this);

            thisItem.parents('li').siblings().removeClass('active');
            thisItem.closest('li').toggleClass('active');
          });

          // Remove extra '/' from any ".tmpl" URL
          if (aHref.match(/tmpl/gi)) {
            aHref2 = item.find('a').attr('href', aHref.replace('//', '/'));
          }

          item.filter(function () {
            return aHref == pathname && aHrefHash == urlHash;
          }).addClass('active');
        });

        // General Information section
        thisFormatter.find('.menu').find('li').each(function (i) {
          var item = $(this);

          aHref = item.find('a').attr('href');
          item.filter(function () {
            return aHref == pathname;
          }).addClass('active');
        });
      });
    }
  };
})(jQuery);
